import { render, staticRenderFns } from "./GateWayRouteModal.vue?vue&type=template&id=95cc2308&scoped=true"
import script from "./GateWayRouteModal.vue?vue&type=script&lang=js"
export * from "./GateWayRouteModal.vue?vue&type=script&lang=js"
import style0 from "./GateWayRouteModal.vue?vue&type=style&index=0&id=95cc2308&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cc2308",
  null
  
)

export default component.exports